///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthKeyValueDTO, UserActivityEventDTO } from '../../generated/shared-types.model';
import { PagedModel } from '../../generated/spring-types.model';
import { DEFAULT_PAGE, DEFAULT_TOTAL_ITEMS } from '../../shared/constants/pagination.constants';
import { SuiUserDTO } from '../../generated/shared-sui-types.model';

export const usersListFeatureKey = 'usersList';

export interface UsersListState {
    isLoading: boolean;
    usersPage: PagedModel<SuiUserDTO>;
    selectedUserActivityEventsPage: PagedModel<UserActivityEventDTO>;
    userEventTypes: GtthKeyValueDTO[];
    showEditButton: boolean;
    currentAccount: SuiUserDTO;
    usersList: SuiUserDTO[];
    totalItems: number;
    pageNumber: number;
    totalPages: number;
}

export const initialState: UsersListState = {
    isLoading: false,
    usersPage: null,
    selectedUserActivityEventsPage: null,
    userEventTypes: null,
    showEditButton: false,
    currentAccount: null,
    usersList: null,
    totalItems: DEFAULT_TOTAL_ITEMS,
    pageNumber: DEFAULT_PAGE,
    totalPages: 0
};
